<app-shell>

  <router-outlet></router-outlet>

</app-shell>